import React, { useEffect, useState } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { GetCountries, GetState, GetCity } from 'react-country-state-city'
import type { City as RCSCCity } from 'react-country-state-city/dist/esm/types'
import { RCSC_SRC } from '../../../../utils/constants'

interface CityInputProps {
  id?: string;
  value: string | undefined;
  stateCode: string | undefined;
  onChange: (event: any, newValue: string) => void;
  error?: boolean;
  helperText?: string;
  placeholder?: string;
  disabled?: boolean;
  paperSx?: any;
  inputSx?: any;
  size?: 'small' | 'medium';
  required?: boolean;
}

export const CityInput = ({
  id,
  value,
  stateCode,
  onChange,
  error,
  helperText,
  placeholder = "City",
  disabled,
  paperSx,
  inputSx,
  size,
  required
}: CityInputProps) => {
  const [cities, setCities] = useState<RCSCCity[]>([])

  useEffect(() => {
    if (!stateCode) {
      setCities([])
      return
    }

    GetCountries(RCSC_SRC).then((countries) => {
      const us = countries.find((c) => c.iso2 === 'US')
      if (!us?.id) return
      GetState(us.id, RCSC_SRC).then((states) => {
        const stateObj = states.find((s) => s.state_code === stateCode)
        if (stateObj) {
          GetCity(us.id, stateObj.id, RCSC_SRC).then((cityResult) => {
            setCities(cityResult)
          })
        } else {
          setCities([])
        }
      })
    })
  }, [stateCode])

  return (
    <Autocomplete
      id={id}
      freeSolo={cities.length === 0}
      fullWidth
      disableClearable
      forcePopupIcon={false}
      disabled={disabled}
      autoHighlight
      autoSelect
      slotProps={{
        paper: { sx: paperSx },
        popper: { disablePortal: true }
      }}
      options={cities.map((c) => c.name)}
      value={value || ''}
      onChange={(_e, newValue) => {
        onChange(_e, (newValue as string) || '')
      }}
      onInputChange={(_e, newInputValue, reason) => {
        if (cities.length === 0 && reason === 'input') {
          onChange(_e, newInputValue)
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          required={required}
          size={size}
          sx={inputSx}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          FormHelperTextProps={{ sx: { marginLeft: 0, marginRight: 0 } }}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  )
}
